import { motion } from "framer-motion";
import { Bot } from "lucide-react";

export function LoadingScreen() {
	return (
		<div className="flex flex-col items-center justify-center h-full gap-4">
			<motion.div
				animate={{ rotate: [0, 360] }}
				transition={{ duration: 2, repeat: Number.POSITIVE_INFINITY, ease: "linear" }}
				className="w-10 h-10 rounded-full border-2 border-primary border-t-transparent"
			/>
			<div className="flex items-center gap-2 text-sm text-muted-foreground">
				<Bot className="w-4 h-4" />
				<span>Connecting to Boring Agent…</span>
			</div>
		</div>
	);
}
